import { useModalState } from "../ModalStateProvider";
import { WizardStepConfig } from "./wizardHelpers";
import {
	useMyReferrer,
	useOriginatorSummary
} from "../../../../services/api-client/useReferrals";

export const useCancelWizard = () => {
	const { openModal } = useModalState();
	const referrerQuery = useMyReferrer();
	const originatorQuery = useOriginatorSummary();

	const startCancelWizard = (
		defaultStep: WizardStepConfig,
		steps: WizardStepConfig[],
		data: Record<string, unknown>,
		onCancel: () => Promise<void>,
		onKeep?: () => void
	) => {
		// Merge referral data into wizard data for conditional steps
		const referrerData = referrerQuery.data;
		const originatorData = originatorQuery.data;

		const enrichedData: Record<string, unknown> = {
			...data,
			// Referrer warning step data
			referrerName: referrerData?.referrerName ?? null,
			referrerPendingCredits: referrerData?.totalPendingCredits ?? 0,
			referrerPhasesAwarded: referrerData?.earnedPhases ?? 0,
			// Originator warning step data
			originatorCreditsEarned: originatorData?.creditsEarned ?? 0,
			originatorCreditsPending: originatorData?.creditsPending ?? 0,
			originatorTotalCredits:
				(originatorData?.creditsEarned ?? 0) +
				(originatorData?.creditsPending ?? 0),
			originatorHasCredits:
				(originatorData?.creditsEarned ?? 0) > 0 ||
				(originatorData?.creditsPending ?? 0) > 0,
			originatorReferralNames: originatorData?.referralNames ?? []
		};

		openModal("CancelWizard", {
			defaultStep,
			steps,
			data: enrichedData,
			onCancel,
			onKeep
		});
	};

	return { startCancelWizard };
};
